module.exports = __webpack_public_path__ + "flyer_background_cake_and_candle_130-8c90b9b304dcb7bf53925c7f51b94a60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_cake_and_candle_130.jpg
// module id = 1613
// module chunks = 1